import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";

import { getUser } from "@/lib/auth";
import { useUserStore } from "@/store/user-store";
import { ErrorBoundary } from "./app/ErrorBoundary";
import { Providers } from "./app/providers";
import { AppRoutes } from "./routes";

/**
 * 앱 루트 컴포넌트
 * Providers: Mantine + TanStack Query + i18n
 * BrowserRouter: React Router SPA 라우팅
 *
 * 부트스트랩: 마운트 시 세션을 복원(getUser → dev 모킹 시 데모 세션)하고
 * setUser + setHydrated 로 표시함. 이게 없으면 AuthGuard 가 isHydrated=false 로
 * 영원히 대기(빈 화면)함. 미인증이면 user=null + hydrated → AuthGuard 가 /login 으로.
 */
export function App() {
  const setUser = useUserStore((s) => s.setUser);
  const setHydrated = useUserStore((s) => s.setHydrated);

  useEffect(() => {
    let active = true;
    getUser()
      .then((user) => {
        if (active) setUser(user);
      })
      .catch(() => {
        /* 미인증/만료 — user 는 null 유지 */
      })
      .finally(() => {
        if (active) setHydrated();
      });
    return () => {
      active = false;
    };
  }, [setUser, setHydrated]);

  return (
    <BrowserRouter>
      <Providers>
        <ErrorBoundary>
          <AppRoutes />
        </ErrorBoundary>
      </Providers>
    </BrowserRouter>
  );
}
